import { activeFilter } from "../../../../services/FilteringUtils";
import PageComponent from "../PageComponent";

class FilteringComponent extends PageComponent {
  constructor(props) {
    super(props);

    this.state = this.initialState();

    this.sortInfo = this.initialSortInfo();

    this._isMounted = false;
    this._resetInProgress = false;
  }

  initialState() {
    return {
      content: [],
      pageInfo: this.initialPageInfo(),
      isLoading: false
    };
  }

  initialSortInfo() {
    return {
      orderBy: "id",
      direction: "asc"
    };
  }

  initialPageInfo() {
    return {
      size: this.initialPageSize(),
      totalElements: 0,
      totalPages: 0,
      number: 0,
      filters: this.initialFilters()
    };
  }

  initialFilters() {
    return { ...activeFilter, ...this.mustFilters() };
  }

  mustFilters() {
    return undefined;
  }

  initialPageSize() {
    return 5;
  }

  getComponentTitle = () => {
    return undefined;
  };

  componentDidMount() {
    super.componentDidMount();
    if (!this.props.dontLoadAfterMount) {
      this.startLoading(this.state.pageInfo, this.sortInfo);
    }
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate() {
    if (this.isComponentRefresh()) {
      //it is refresh of the component, caused by onMenuItemClick in PageContainer, i.e. after side menu (same) item click
      this._resetInProgress = true;
      this.resetComponent();
      this._resetInProgress = false;
      if (!this.props.dontLoadAfterMount) {
        this.startLoading(this.state.pageInfo, this.sortInfo);
      }
    }
  }

  onActiveButtonChange = selectedFilter => {
    let pageInfo = this.state.pageInfo;
    pageInfo.filters.active = selectedFilter.active;
    pageInfo.number = 0;
    if (this.state.searchValue && this.state.searchValue !== "") {
      pageInfo = this.createSearchInfo(this.state.searchValue, pageInfo);
    }
    this.setState({ pageInfo: pageInfo });
    this.startLoading(pageInfo, this.sortInfo);
  };

  startLoading = (pageInfo, sortInfo) => {
    throw new Error("startLoading must be implemented!");
  };

  renderProps() {
    return {
      ...super.renderProps(),
      data: this.state.content,
      pageInfo: this.state.pageInfo,
      sortInfo: this.sortInfo,
      onActiveButtonChange: this.onActiveButtonChange
    };
  }
}

export default FilteringComponent;
